import { AxiosResponse } from 'axios'
import { ServiceConfig } from 'shared/services/ServiceConfig'

import { ITermosUsoRepository } from '../../domain/repositories/ITermosUsoRepository'

const http = new ServiceConfig()
export default class TermosUsoRepository implements ITermosUsoRepository {
  public async find(): Promise<string> {
    const response: AxiosResponse<string> = await http.get('/termos-uso', {
      params: {
        type: 'html',
      },
    })
    return response.data
  }
}
